import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5749e72a&"
import script from "./main.vue?vue&type=script&lang=ts&"
export * from "./main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports